module.exports = "/_next/static/images/interview-screenshot-44d221e8411d8aea6f5b862877a519d3.jpg";